/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IActivityEventTypesDataState } from "Interfaces/SiteContent/IActivityEventTypesDataState";

import {
  IGetActivityEventTypesFailure,
  IGetActivityEventTypesSuccess,
} from "./ActivityEventTypesAction";
import {
  ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_FAILURE,
  ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_SUCCESS,
} from "./ActivityEventTypesActionTypes";

export const initialState: IActivityEventTypesDataState = {
  activityEventTypesData: [],
};

/**
 * Updates state of fetch activity event types success.
 * @param {IActivityEventTypesDataState} state The activity event types state.
 * @param {IGetActivityEventTypesSuccess} action The activity event types action success.
 * @returns {IActivityEventTypesDataState} New activity event types state.
 */
const applyLoadActivityEventTypesSuccess = (
  state: IActivityEventTypesDataState,
  action: IGetActivityEventTypesSuccess
): IActivityEventTypesDataState => {
  return {
    ...state,
    activityEventTypesData: action.activityEventTypes,
  };
};

/**
 * Updates state of fetch activity event types failure.
 * @param {IActivityEventTypesDataState} state The activity event types state.
 * @param {IGetActivityEventTypesFailure} action The activity event types action failure.
 * @returns {IActivityEventTypesDataState} New technology area state.
 */
const applyLoadActivityEventTypesFailure = (
  state: IActivityEventTypesDataState,
  action: IGetActivityEventTypesFailure
): IActivityEventTypesDataState => ({
  ...state,
  errorMessage: action.activityEventTypesLoadError,
});

/**
 * Reducer function for activity event types.
 * @param state activity event types state.
 * @param action action.
 * @returns {IActivityEventTypesDataState} New activity event types state.
 */
function activityAndEventTypesReducer(
  state: IActivityEventTypesDataState = initialState,
  action
): IActivityEventTypesDataState {
  switch (action.type) {
    case ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_SUCCESS:
      return applyLoadActivityEventTypesSuccess(state, action);
    case ACTIVITY_TYPE_EVENT_TYPE_DATA_LOAD_FAILURE:
      return applyLoadActivityEventTypesFailure(state, action);
    default:
      return state;
  }
}

export default activityAndEventTypesReducer;
